import { useMemo } from 'react';

import { Divider, List, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { NavigationCollapse } from '@kit/navigation/navigation-collapse';
import { NavigationItem } from '@kit/navigation/navigation-item';

import { NavigationGroupDividerSX } from './styled';
import { NavigationGroupType } from './types';

export const NavigationGroup: NavigationGroupType = (props) => {
  const { item } = props;

  const theme = useTheme();

  // menu list collapse & items
  const items = useMemo(
    () =>
      item.children?.map((menu) => {
        switch (menu.type) {
          case 'collapse':
            return <NavigationCollapse key={menu.id} menu={menu} level={1} />;
          case 'item':
            return <NavigationItem key={menu.id} item={menu} level={1} />;
          default:
            return (
              <Typography
                key={menu.id}
                variant="h6"
                color="error"
                align="center"
              >
                Menu Items Error
              </Typography>
            );
        }
      }),
    [item.children]
  );

  return (
    <>
      <List
        subheader={
          item.title && (
            <Typography
              variant="caption"
              sx={{ ...theme.typography.menuCaption }}
              display="block"
              gutterBottom
            >
              {item.title}

              {item.caption && (
                <Typography
                  variant="caption"
                  sx={{ ...theme.typography.subMenuCaption }}
                  display="block"
                  gutterBottom
                >
                  {item.caption}
                </Typography>
              )}
            </Typography>
          )
        }
      >
        {items}
      </List>

      <Divider sx={NavigationGroupDividerSX} />
    </>
  );
};
